import { Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { renderProgress } from "components/atoms/PercentProgressCell";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { IRelatedDocument } from "model";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoadingOrderActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { translations, I18nTranslator } from "utils/i18n";

interface IProductListProps {
  doImportCode: string;
}
const RelatedDocumentList = (props: IProductListProps) => {
  const { doImportCode } = props;
  const dispatch = useDispatch();
  const data = useAppSelector(
    (state) => state.LoadingOrderReducer.relatedDocument.data!
  );
  const headerAction = useAppSelector(
    (state) => state.LoadingOrderReducer.action
  );
  const action = useAppSelector(
    (state) => state.LoadingOrderReducer.relatedDocument.action
  );
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    _getRelatedDocuments();
  }, [
    searchText,
    headerAction.includes(
      LoadingOrderActions.importLoadingOrderDocument.successName
    ),
  ]);

  const _getRelatedDocuments = (pageNumber = 1) => {
    dispatch(
      LoadingOrderActions.getRelatedDocuments.request({
        pageNumber: pageNumber,
        pageSize: 100,
        doImportCode: doImportCode,
        searchText: searchText,
      })
    );
  };

  const _handlePageSizeChange = (pageSize: number) => {
    dispatch(
      LoadingOrderActions.getRelatedDocuments.request({
        pageNumber: 1,
        pageSize: pageSize,
        doImportCode: doImportCode,
        searchText: searchText,
      })
    );
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "deliveryDate",
      headerName: I18nTranslator(translations.receive.deliveryDate),
      size: "small",
      align: "left",
      sortable: true,
      renderCell: ({ value }) => (
        <Typography>{moment(value).format("DD/MM/YYYY")}</Typography>
      ),
    }),

    TableHelper.createCell({
      field: "companyCode",
      headerName: I18nTranslator(translations.receive.companyId),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "companyName",
      headerName: I18nTranslator(translations.receive.companyName),
      size: "full",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "prStatus",
      headerName: I18nTranslator(translations.receive.prepareTicketStatus),
      size: "medium",
    }),

    TableHelper.createCell({
      field: "dhStatus",
      headerName: I18nTranslator(translations.receive.deliveryTicketStatus),
      size: "medium",
    }),
    TableHelper.createCell({
      field: "prepareProgress",
      headerName: I18nTranslator(translations.receive.preparedProgressPercent),
      size: "small",
      align: "left",
      sortable: true,
      type: "number",
      renderCell: renderProgress,
    }),
    TableHelper.createCell({
      field: "deliveryProgress",
      headerName: I18nTranslator(translations.receive.deliveryProgressPercent),
      size: "small",
      align: "left",
      sortable: true,
      type: "number",
      renderCell: renderProgress,
    }),
  ];
  return (
    <AppTable<IRelatedDocument>
      loading={action.includes(
        LoadingOrderActions.getRelatedDocuments.requestName
      )}
      data={data}
      columns={COLUMNS}
      hideAddNew
      onSearch={setSearchText}
      searchPlaceholder={I18nTranslator(
        translations.placeholder.searchRelatedDocument
      )}
      onChangePage={(pageNumber: number) => _getRelatedDocuments(pageNumber)}
      removeActionColumn
      hideHeader
      defaultHeaderTable={230}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default RelatedDocumentList;
